
import { ValidationObserver, ValidationProvider } from 'vee-validate'
import { mapActions, mapState } from 'vuex'
import { mdiTextBoxSearch } from '@mdi/js'
import catalog from '@/components/tools/catalog'

export default {

  components: {
    ValidationObserver, ValidationProvider
  },
  props: {
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      mdiTextBoxSearch,
      receiveEmails: true,
      dialog: false,
      name: undefined,
      savedSearch: undefined,
      step: 1
    }
  },
  async fetch () {
    await this.hasCustomersAnySearches()

    try {
      if ('ssid' in this.$route.query) {
        const searchId = this.$route.query.ssid
        try {
          const { data } = await this.$axios.get(`/private/customer/search/get/${searchId}`)
          this.savedSearch = data
          this.name = data.name
        } catch (e) {
          console.error(e)
        }
      } else {
        // this.reloadName()
      }
    } catch (e) {
      console.error(e)
    }
  },

  computed: {
    ...mapState('catalog', {
      filterAttributes (state) {
        return state.filterAttributes
      }
    }),
    ...mapState('customer', {
      hasAnySearches: 'hasAnySearches'
    }),

    dialogTitle () {
      if (this.step === 2) {
        if (this.savedSearch) {
          return this.$t('catalog.save_search_success.update')
        }
        return this.$t('catalog.save_search_success')
      }

      const translationKey = this.savedSearch ? 'catalog.update_your_search' : 'catalog.save_search'

      return this.$t(translationKey)
    },

    buttonTitle () {
      const translationKey = this.savedSearch ? 'catalog.update_search' : 'catalog.save_search'

      return this.$t(translationKey)
    },

    dialogTextLabel () {
      return this.$t('catalog.search_name')
    }
  },

  mounted () {
  },
  methods: {
    ...mapActions('customer', {
      hasCustomersAnySearches: 'hasCustomersAnySearches'
    }),

    cancel () {
      this.dialog = false
      this.step = 1
    },

    async submit () {
      if (this.step === 1) {
        await this.upsertSearch()
        this.step = 2
      } else {
        this.step = 1
        this.dialog = false
        this.savedSearch = undefined
        this.name = undefined

        await this.$router.push(this.localePath({
          name: 'catalog',
          query: {
            auction_status: 'running'
          }
        }))
      }
    },

    async upsertSearch () {
      if (this.savedSearch) {
        await this.updateSearch()
      } else {
        await this.saveSearch()
        await this.hasCustomersAnySearches()
      }
    },

    async saveSearch () {
      const queryDict = this.$route.query
      queryDict.auction_status = 'running'
      const query = catalog.queryObjectToQueryString(queryDict)

      const data = {
        query,
        name: this.name,
        receiveEmails: true // this.receiveEmails
      }
      await this.$axios.post('/private/customer/search/save', data)
    },

    async updateSearch () {
      const query = {}
      for (const [key, value] of Object.entries(this.$route.query)) {
        if (key in this.filterAttributes) {
          query[key] = value
        }
      }
      query.auction_status = 'running'

      this.savedSearch.query = catalog.queryObjectToQueryString(query)
      this.savedSearch.name = this.name

      await this.$axios.put('/private/customer/search/update', this.savedSearch)
    }

  }
}
